import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import { no_image_product_details } from "../../constant";

function ProductImagesSlider(props) {
  const { productDetails } = props;
  const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const slider1 = useRef(null);
  const slider2 = useRef(null);

  useEffect(() => {
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, []);

  return (
    <>
      <div className="product-slide">
        {productDetails?.images?.[0] ? (
          <>
            <Slider asNavFor={nav2} ref={slider1} arrows={false}>
              {productDetails?.images?.map((item, index) => {
                return (
                  <div
                    className="product-images mainimage-container"
                    key={index}
                  >
                    <figure className="big_images_nutrients_slider_figure">
                      <img
                        src={`${ImageUrlRedux?.product_image_url}/${item}`}
                        className="img-fluid big_images_nutrients_slider"
                      />
                    </figure>
                  </div>
                );
              })}
            </Slider>

            <Slider
              asNavFor={nav1}
              ref={slider2}
              slidesToShow={
                productDetails?.images?.length > 0 ||
                productDetails?.images?.length < 3
                  ? productDetails?.images?.length
                  : 3
              }
              swipeToSlide={true}
              focusOnSelect={true}
              arrows={false}
              className="slick-custom"
            >
              {productDetails?.images?.map((item, index) => {
                return (
                  <div className="inner-image-container" key={index}>
                    <figure className="small_images_nutrients_slider_figure">
                      <img
                        src={`${ImageUrlRedux?.product_image_url}/${item}`}
                        alt=""
                        className="image-fluid image-width small_images_nutrients_slider"
                      />
                    </figure>
                  </div>
                );
              })}
            </Slider>
          </>
        ) : (
          <img
            className="no_image_avatar_product_details"
            src={`${
              productDetails?.thumbnail
                ? `${ImageUrlRedux?.product_thumbnail_url}/${productDetails?.thumbnail}`
                : no_image_product_details
            }`}
          />
        )}
      </div>
    </>
  );
}

export default ProductImagesSlider;
